export default {
  "cycleProFeature": {
    "title": "Fitur Siklus Pro",
    "description": "Anda bisa menggunakan fitur ini serta fitur lengkap lainnya dengan melakukan aktivasi Siklus Pro.",
    "more": "Ketahui lebih lanjut"
  },
  "dateTimeFilter": {
    "dateAfter": "Dari tanggal",
    "dateBefore": "Sampai tanggal",
    "time": "Waktu",

    "all": "Semua",
    "am": "Pagi",
    "pm": "Sore",

    "apply": "Terapkan",
    "reset": "Reset",
  },
  "multipleImageInput": {
    "camera": "Kamera",
    "image": "Galeri"
  },
  "onboardNewFeatureModal": {
    "showFeature": "Lihat Fitur",
    "skipFeature": "Tutup",
    "newFeature": "Fitur Baru",
    "titleFeature1": "Monitoring Biaya",
    "textFeature1": "Pantau estimasi biaya operasional setiap hari sebagai alternatif menilai potensi keuntungan/kerugian.",
    "titleFeature2": "Grafik Biaya Operasional",
    "textFeature2": "Tampilan grafik estimasi untuk mempermudah melihat potensi keuntungan/kerugian hingga akhir siklus.",
    "contentOverview": "Geser area ini untuk melihat nilai biaya/operasional tambak.",
    "contentItemOverview": "Pilih salah satu kotak untuk melihat detail per kolam.",
    "contentTabOverview": "Anda dapat melihat informasi lain dengan lebih cepat melalui tab.",
    "contentGraphOverview": "Anda juga dapat melihat trend biaya pada menu grafik.",
    "contentTabGraphOverview": "Baru!\nGrafik untuk monitoring biaya",
    "contentItemGraphOverview": "Pantaun estimasi biaya melalui grafik, anda juga bisa scroll ke bawah untuk melihat grafik lainnya.",
    "contentFilterGraphOverview": "Lihat grafik lainnya lebih cepat melalui filter ini.",
  },
  "onboardModal": {
    "welcomeTitle": "Selamat Datang di JALA",
    "welcomeDescription": "Ikuti panduan untuk mulai manajemen budidaya Anda.",
    "welcomeAction": "Ikuti Panduan",
    "welcomeSkipAction": "Nanti Saja",
    "welcomeBanner": "Jika Anda petambak udang, beralih ke mode budidaya di sini.",
    "welcomeMenuOther": "Jelajahi layanan lainnya untuk pelajari informasi budidaya dan uji coba bertambak.",
    "welcomeOverview": "Pantau data utama dari seluruh kolam Anda di sini.",
    "welcomeOverviewCreateSomething": "Mulai perjalanan budidaya dengan buat %{something}.",
    "welcomeMenu": "Jelajahi layanan lainnya yang dapat bantu proses bertambak.",
    "welcomeHome": "",
    "welcomeQuickInput": "Masukkan data budidaya Anda di sini.",
    "welcomeActivity": "Kelola aktivitas harian tanpa takut terlewat.",
    "welcomeMonitoring": "Dapatkan hasil analisis seluruh kolam Anda di sini.",

    "consultationTitle": "Kini Anda dapat berkonsultasi seputar budidaya",
    "consultationDescription": "Ada masalah budidaya? Konsultasikan bersama para ahli dari JALA!.",

    "newMenuTitle": "Baru! Fitur aktivitas harian ",
    "newMenuSubtitle": "Kelola aktivitas harian dan input data budidaya lebih mudah dan cepat"
  },
  "offlineMode": {
    "resetRequireInternet": "Reset memerlukan konektivitas internet",
  },
  "shrimpPriceFilter": {
    "country": "Negara",
    "region": "Lokasi",
    "time": "Update Harga",
    "supplier": "Supplier",

    "regionLabel": "Pilih Lokasi",
    "timeLabel": "Pilih Update Harga",

    "now": "Terbaru",
    "week": "> 1 Minggu",
    "month": "> 1 Bulan",

    "all": "Semua",
    "verified": "Terverifikasi",

    "apply": "Terapkan",
    "reset": "Reset",
  },
  "listEmpty": {
    "text": "Belum ada data tersimpan"
  },
  "listNetworkError": {
    "refreshPage": "Refresh Halaman"
  },

  "astoCoachmark": {
    "connection": "Indikator Jika Asto telah terhubung dengan Bluetooth atau Wifi",
    "resetButton": "Reset untuk mengembalikan perubahan ke kondisi semula",
    "saveButton": "Anda dapat menggunakan fitur 'Simpan' sebelum mengunggahnya",
    "uploadButton": "Upload data yang telah kamu tambahkan",
    "feedTable": "Anda dapat menggunakan data yang telah di inputkan pada fitur input pakan",
    "todayFeed": "Isi total pemberian pakan dalam sehari",
    "todayFeedNormal": "Sesuaikan porsi dengan jam pakan yang ada di Tambak",
    "nextDayFeed": "Anda juga dapat menambahkan data pakan selama satu minggu",
  }
}
